import { Component, OnInit, Inject } from '@angular/core';

import { Subscription } from 'rxjs/Subscription';
import { MeasurementToolsViewModel, CreateMeasurementPointModel, WSREMeasurementPoints, MeasurementPointsViewModel } from '../model/measurement-points.model';
import { LoadingService } from '../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../../../shared/models/FileReader';
import { MeasurementPonitsService } from '../services/measurement-points-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-wsre-subcomponent',
  templateUrl: './add-wsre-subcomponent.component.html',
  styleUrls: ['./add-wsre-subcomponent.component.scss']
})
export class AddWsreSubcomponentComponent implements OnInit {

  subCompName:string;
  compartId:number;
  isLoading:boolean=false;
  WSREMeasurmentPoints: WSREMeasurementPoints[]; 
  
  constructor(
    private _measurementPointsService: MeasurementPonitsService,
    private _loading: LoadingService,
    public dialogRef: MatDialogRef<AddWsreSubcomponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
  ) { }


  ngOnInit() {
    this.compartId = this.data.compartId;

    if(this.compartId>0){
      this.LoadWSRESubComponents();
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }

  LoadWSRESubComponents(){
    this._measurementPointsService.getWSREMeasurmentPointForFrame(this.compartId).subscribe(r => {
      console.log("getWSREMeasurmentPointFrame", r)
      this.isLoading = false
      if (r.length > 0) {
        this.WSREMeasurmentPoints = r;
      }


    })
  }

  isFirstComponentInList(item, index) {
  
    if (this.WSREMeasurmentPoints.indexOf(item) == 0) {
        return true;
    }
    return false;
  }
  
  isLastComponentInList(item, index) {
    if (this.WSREMeasurmentPoints.indexOf(item) == this.WSREMeasurmentPoints.length - 1) {
        return true;
    }
    return false;
  }

  AddNewWSRESubComp(){
    if(this.subCompName==""){
      this._notification.error("Please add a Sub component Name")
    }

    if(this.subCompName!=""){
      this._measurementPointsService.AddWSRESubComponent(this.subCompName).subscribe(res=>{
        if(res==true){
          this._notification.success("Saved Sucessfully")
          this.LoadWSRESubComponents();
        }else{
          this._notification.error("Error,Please Contact Tracktreads")
        }
      })

    }
  }

  OrderUP(order:number, formId:number){
    this._measurementPointsService.OrderUp_WSRESubComponent(formId,order).subscribe(res=>{
      this.LoadWSRESubComponents();
    })
  }
  OrderDown(order:number, formId:number){
    this._measurementPointsService.OrderDown_WSRESubComponent(formId,order).subscribe(res=>{
      this.LoadWSRESubComponents();
    })
  }
  
}
